import { useNavigate } from "react-router-dom";
import { useState, useEffect, useMemo } from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { Encryptedid } from "../../Util/BcruptEncyptid";
import { groupData } from "../../Constant/ConstantData";

const CustomCarousel = ({
  videoData = [],
  type,
  redirection,
  imgHeight,
  isFullWidth = false,
}) => {
  const [current, setCurrent] = useState(0);
  const [slideCount, setSlideCount] = useState(() => {
    if (typeof window === "undefined") return isFullWidth ? 7 : 4;
    if (window.innerWidth <= 576) return 1;
    if (window.innerWidth <= 768) return isFullWidth ? 3 : 2;
    if (window.innerWidth <= 992) return isFullWidth ? 4 : 3;
    if (window.innerWidth <= 1200) return isFullWidth ? 5 : 3;
    if (window.innerWidth <= 1440) return isFullWidth ? 7 : 4;
    if (window.innerWidth <= 1680) return isFullWidth ? 7 : 4;
    return isFullWidth ? 7 : 4;
  });

  const navigate = useNavigate();

  // Deduplicate videoData by ID/title to prevent any duplicate video objects
  const uniqueVideoData = useMemo(() => {
    if (!Array.isArray(videoData)) return [];
    const seen = new Set();
    return videoData.filter((item) => {
      const id = item?._id || item?.id || item?.title;
      if (!id || seen.has(id)) return false;
      seen.add(id);
      return true;
    });
  }, [videoData]);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 576) setSlideCount(1);
      else if (window.innerWidth <= 768) setSlideCount(isFullWidth ? 3 : 2);
      else if (window.innerWidth <= 992) setSlideCount(isFullWidth ? 4 : 3);
      else if (window.innerWidth <= 1200) setSlideCount(isFullWidth ? 5 : 3);
      else if (window.innerWidth <= 1440) setSlideCount(isFullWidth ? 7 : 4);
      else if (window.innerWidth <= 1680) setSlideCount(isFullWidth ? 7 : 4);
      else setSlideCount(isFullWidth ? 7 : 4);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [isFullWidth]);

  useEffect(() => {
    setCurrent(0);
  }, [videoData]);

  if (!uniqueVideoData?.length) {
    return <p className="text-center">No videos available</p>;
  }

  const maxIndex = Math.max(0, uniqueVideoData.length - slideCount);
  const canGoPrev = current > 0;
  const canGoNext = current < maxIndex;

  const nextSlide = () => {
    if (canGoNext) {
      setCurrent((prev) => Math.min(prev + 1, maxIndex));
    }
  };

  const prevSlide = () => {
    if (canGoPrev) {
      setCurrent((prev) => Math.max(prev - 1, 0));
    }
  };

  const getVisibleSlides = () => {
    const count = Math.min(uniqueVideoData.length, slideCount);
    const start = Math.min(current, maxIndex);
    return uniqueVideoData.slice(start, start + count).map((item, idx) => ({
      ...item,
      originalIndex: start + idx,
    }));
  };

  const gotoPlayback = (id, video_Id, slide) => {
    navigate(`/video-shorts/${Encryptedid(id)}/${video_Id}`, {
      state: { page: "dashboard", videoObj: slide },
    });
  };

  const showNavigation = uniqueVideoData.length > slideCount;

  return (
    <Container className="popular-data-sec position-relative text-center" fluid>
      <Row className="justify-content-start px-1 mb-2 g-2 flex-nowrap">
        {getVisibleSlides()?.map((slide, index) => (
          <Col
            key={slide._id || slide.id || index}
            style={{
              flex: `0 0 ${100 / slideCount}%`,
              maxWidth: `${100 / slideCount}%`,
            }}
            className="d-flex justify-content-center"
          >
            <Card
              className="custom-card shadow-sm border-0"
              style={{
                borderRadius: "16px",
                overflow: "hidden",
                maxWidth: "100%",
                width: "100%",
              }}
            >
              <div style={{ position: "relative" }}>
                <Card.Img
                  variant="top"
                  src={
                    slide.cover_url || require("../../Assets/Images/clogo.png")
                  }
                  alt={slide.title}
                  style={{
                    height: imgHeight || "345px",
                    width: "100%",
                    objectFit: "cover",
                    objectPosition: "center top",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    if (redirection) {
                      const catId =
                        slide.category?._id ||
                        slide.categoryId?._id ||
                        slide.category ||
                        slide.categoryId ||
                        "";
                      gotoPlayback(catId, slide._id, slide);
                    }
                  }}
                />
              </div>

              <Card.Body className="text-start p-2">
                <div className="new-icons-main">
                  <div className="new-icons-sec">
                    <h6>{slide.title}</h6>
                  </div>
                  <div className="insight-sec d-flex">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      aria-hidden="true"
                      role="img"
                    >
                      <rect
                        x="3"
                        y="8"
                        width="4"
                        height="13"
                        rx="1.5"
                        fill="#6070A8"
                      />
                      <rect
                        x="10"
                        y="4"
                        width="4"
                        height="17"
                        rx="1.5"
                        fill="#6070A8"
                      />
                      <rect
                        x="17"
                        y="11"
                        width="4"
                        height="10"
                        rx="1.5"
                        fill="#6070A8"
                      />
                    </svg>
                    <h6>#{(slide.originalIndex ?? index) + 1}</h6>
                  </div>

                  {slide?.shares && slide.shares.length > 0 ? (
                    <div className="share-details mt-2 border-top pt-2 text-start">
                      <div
                        style={{
                          fontSize: "14px",
                          color: "#6070A8",
                          marginBottom: "4px",
                        }}
                      >
                        <strong>Shared By:</strong>{" "}
                        {slide.shares[0].sharedBy?.name} (
                        {slide.shares[0].sharedBy?.role})
                      </div>
                      <div
                        style={{
                          fontSize: "14px",
                          color: "#6070A8",
                          marginBottom: "4px",
                        }}
                      >
                        <strong>Org:</strong>{" "}
                        {slide.shares[0].organisation?.name}
                      </div>
                      <div style={{ fontSize: "14px", color: "#6070A8" }}>
                        <strong>Total Shares:</strong> {slide.totalSharedCount}
                      </div>
                    </div>
                  ) : type !== "Staff" ? (
                    <>
                      <div className="insight-sec d-flex">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="28"
                          height="28"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="#6070A8"
                          strokeWidth="1.8"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <path d="M2.5 12s3.5-7.5 9.5-7.5S21.5 12 21.5 12s-3.5 7.5-9.5 7.5S2.5 12 2.5 12z" />
                          <circle cx="12" cy="12" r="3.2" />
                        </svg>
                        <h6>
                          {slide?.views || 0}{" "}
                          {slide?.views === 1 ? "view" : "views"}
                        </h6>
                      </div>
                      <div className="insight-sec d-flex">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="#6070A8"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <path d="M20.8 8.6c0 6.1-7.3 10.6-8.3 11.3-1-.7-8.3-5.2-8.3-11.3C4.2 6 6.5 4 9.2 4c1.6 0 3 .8 3.6 2 0.6-1.2 2-2 3.6-2 2.7 0 5 2 5 4.6z" />
                        </svg>
                        <h6>
                          {slide?.likes || 0}{" "}
                          {slide?.likes === 1 ? "like" : "likes"}
                        </h6>
                      </div>
                      <div className="insight-sec d-flex">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="#6070A8"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z" />
                        </svg>
                        <h6>
                          {slide?.saves || 0}{" "}
                          {slide?.saves === 1 ? "save" : "saves"}
                        </h6>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="insight-sec d-flex my-2">
                        <h6 style={{ fontSize: "14px" }}>
                          {slide?.categoryTitle}
                        </h6>
                      </div>
                      <div className="d-flex flex-wrap gap-1">
                        {slide?.group?.map((id, index) => {
                          const group = groupData.find((g) => g.id === id);
                          return (
                            group?.name && (
                              <button
                                key={`${id}-${index}`}
                                className="group-button rounded-pill text-nowrap m-0"
                                style={{ fontSize: "9px" }}
                                title={group.name}
                              >
                                {group.name}
                              </button>
                            )
                          );
                        })}
                      </div>{" "}
                    </>
                  )}
                </div>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>

      {showNavigation && (
        <>
          <button
            onClick={prevSlide}
            disabled={!canGoPrev}
            className="left-btn"
            style={{
              position: "absolute",
              top: "42%",
              left: "-19px",
              transform: "translateY(-50%)",
              background: "transparent",
              border: "none",
              padding: 0,
              zIndex: 10,
              cursor: canGoPrev ? "pointer" : "not-allowed",
              opacity: canGoPrev ? 1 : 0.3,
            }}
          >
            <svg
              width="40"
              height="40"
              viewBox="0 0 48 48"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M30 12 L30 36 L12 24 Z" fill="#2E3472" />
            </svg>
          </button>

          <button
            onClick={nextSlide}
            disabled={!canGoNext}
            className="right-btn"
            style={{
              position: "absolute",
              top: "42%",
              right: "26px",
              transform: "translateY(-50%)",
              background: "transparent",
              border: "none",
              padding: 0,
              zIndex: 10,
              cursor: canGoNext ? "pointer" : "not-allowed",
              opacity: canGoNext ? 1 : 0.3,
            }}
          >
            <svg
              width="40"
              height="40"
              viewBox="0 0 48 48"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M18 12 L18 36 L36 24 Z" fill="#2E3472" />
            </svg>
          </button>
        </>
      )}
    </Container>
  );
};

export default CustomCarousel;
